/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import { breakpoints } from '@coursera/cds-core';

import AutoCompleteableInput from 'bundles/onboarding-2022/components/shared/AutoCompleteableInput';
import { getIndustries } from 'bundles/onboarding-2022/data/constants';
import type {
  Industry,
  Occupation,
  UserEntryAutoCompletePropsFromCaller as PropsFromCaller,
  UserEntryAutoCompleteProps,
} from 'bundles/onboarding-2022/types/AutoCompleteableInputProps';

type PropsToComponent = PropsFromCaller & UserEntryAutoCompleteProps;

const EMPTY_OCCUPATION = { id: '', name: '' };

const styles = {
  container: css`
    width: 600px;
    margin: 0 auto;

    ${breakpoints.down('xs')} {
      width: 100%;
    }
  `,
};

export const UserEntryAutoComplete: React.FC<PropsToComponent> = ({
  occupations,
  question,
  value,
  questionId,
  onChange,
}) => {
  const [val, setVal] = useState<Occupation | Industry>();
  const getOptions = () => {
    if (questionId === 'interestedIndustry') {
      return getIndustries();
    } else {
      return occupations || [];
    }
  };
  const getOptionById = (id: string | undefined) => {
    if (id) {
      if (questionId === 'interestedIndustry') {
        const industryOptions = getIndustries();
        return industryOptions?.filter((option) => option.id && option.id === id)[0];
      } else {
        return occupations?.filter((option) => option.id && option.id === id)[0];
      }
    }
  };

  useEffect(
    () => {
      if (value?.id) {
        const option = getOptionById(value.id);
        setVal(option);
      } else if (value?.otherText) {
        setVal({ id: value.otherText.trim(), name: value.otherText.trim() });
      } else {
        setVal(EMPTY_OCCUPATION);
      }
    }, // FIXME: existing react-hooks/exhaustive-deps violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (!val) return null;
  return (
    <div css={styles.container}>
      <AutoCompleteableInput
        allOptions={getOptions()}
        defaultValue={val}
        questionId={questionId}
        onChange={onChange}
        question={question}
      />
    </div>
  );
};

export default UserEntryAutoComplete;
